import React from 'react';
import './InfoModal.css'; // Assuming similar styling

const ChangelogModal = ({ isOpen, onClose, version }) => {
  if (!isOpen) return null;

  return (
    <div className="info-modal-overlay">
      <div className="info-modal-content">
        <div className="info-modal-header">
          <h2>更新履歴</h2>
          <button className="info-modal-close-button" onClick={onClose}>×</button>
        </div>
        <div className="info-modal-body">
          <p>現在のバージョン: {version}</p>
          <h3>Version 0.8.4 (2026/10/29)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：「不干渉主義」のような、相手のパラメーター増減に関わる能力が正常に動作しない問題(ver0.7.3より発生)を修正。</li>
            <li><font color="yellow">仕様追加</font>：カード詳細のカード名にフリガナを追加。</li>
            <li><font color="yellow">機能調整</font>：対戦中BGMをブラウザタブ切替中に一時停止するように変更。</li>
            <li><font color="yellow">仕様追加</font>：デッキ構築画面に「テキスト絞込」を追加。</li>
            <li><font color="yellow">仕様追加</font>：デッキ選択画面に「プレイ記録」を追加。</li>
            <li>　ローカルの対戦データを記録し、JSON形式で保存し出力できます。</li>
            <li>　※出力時、ブラウザに保存済みのデータは削除されます。</li>
            <li>　※初期状態では記録が無効です。「プレイ記録＞プレイ記録を取る」から有効化できます。</li>
          </ul>
          <h3>Version 0.8.1 (2026/10/20)</h3>
          <ul>
            <li><font color="yellow">表記調整</font>：大部分のカードテキストを調整。</li>
            <li>　カード能力を分かりやすく表現するよう、英訳も併せて調整。一部仕様をキーワード能力としてルールへ追記。</li>
          </ul>
          <h3>Version 0.8.0 (2026/10/16)</h3>
          <ul>
            <li><font color="yellow">機能追加</font>：テストモード「仮説検証」を「限界検証」に追加。</li>
            <li>　対局設定や各プレイヤーのデッキをカスタマイズし、任意の状況を再現できるテストモードです。</li>
            <li>　カード性能や組み合わせの検証にご活用ください！</li>
          </ul>
          <h3>Version 0.7.10 (2026/10/10)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：「世の常」に新たな記憶と進行を追加。</li>
            <li>　記憶「財宝と名声」：規模ボーナス獲得時、同値の意識ボーナスとカード1枚を獲得。</li>
            <li>　進行「対話の秋(とき)」：意識とカードを交換したり、特殊な「文化摩擦」が発生する。</li>
          </ul>
          <h3>Version 0.7.9 (2026/10/03)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：マリガン画面に手番表示を追加。</li>
            <li><font color="yellow">仕様変更</font>：「世の常」に「検証記録」を追加。</li>
            <li><font color="yellow">仕様変更</font>：「世の常」の終着点に専用BGMを追加。</li>
          </ul>
          <h3>Version 0.7.7 (2026/09/07)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：対戦終了時に決着詳細演出を追加。</li>
          </ul>
          <h3>Version 0.7.6 (2026/08/24)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：一部カード効果の調整。</li>
            <li>　「共産主義」：ターン開始時の場の財をすべて手札に戻す効果において「耐久値と必要規模は維持される」よう変更。</li>
            <li>　　変更経緯：このカードを中心とした展開を助け、戦術の幅を狭まりにくくするため。</li>
          </ul>
          <h3>Version 0.7.5 (2026/08/12)</h3>
          <ul>
            <li><font color="yellow">仕様追加</font>：デッキの残り枚数が少なくなった時の強調エフェクトを追加。</li>
          </ul>
          <h3>Version 0.7.4 (2026/07/28)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：一部カード効果の調整。</li>
            <li>　「啓蒙時代」：「自分の意識-2」を追加し、選択したイデオロギーカードを手札ではなく、デッキの一番上に加えるよう変更。</li>
            <li>　　変更経緯：使用された相手側の介入余地を高めるため。</li>
            <li>　「交易路」：必要規模を6→3へ変更。</li>
            <li>　　変更経緯：序盤における規模獲得の安定性を高めるため。</li>
          </ul>
          <h3>Version 0.7.3 (2026/07/14)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：意識/規模の軽減や増幅に関する効果が、無効になっても1度だけ反応する不具合を修正。</li>
          </ul>
          <h3>Version 0.7.2 (2026/07/06)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：「世の常」：一部の進行に効果を追加。相手デッキを調整。</li>
            <li><font color="yellow">仕様変更</font>：「一神教」に「自分の場の財が受けるダメージ-1」を、「聖典」に「自分が受ける意識減少-1」を追加。</li>
          </ul>
          <h3>Version 0.7.1 (2026/07/04)</h3>
          <ul>
            <li><font color="yellow">仕様調整</font>：「世の常」記憶：部族の闘争に追加の効果を付与。</li>
          </ul>
          <h3>Version 0.7.0 (2026/06/25)</h3>
          <ul>
            <li><font color="yellow">仕様追加</font>：BGMの追加。</li>
            <li><font color="yellow">新ゲームモード追加</font>：「世の常」の追加。</li>
            <li>「世の常」は、カードを集めてデッキを作りながら進行し、終着点に待つ強力なデッキの撃破を目指すゲームモードです。</li>
            <li>タイトル画面に「限界検証」が追加され、「世の常」を始めることができます。</li>
            <li>「世の常」では対戦を含め、様々な"進行"が存在します。</li>
            <li>　「文化摩擦」：対戦を行います。勝利すると、相手が対戦中に持っていたカード等からランダムにカードを獲得します。</li>
            <li>　「俯瞰者の気紛れ」：モード中に蓄積できる"規模ボーナス"を消費して、デッキのカードを交換できます。</li>
            <li>　「文明を研ぐ」：デッキからカードを削除することができます。</li>
            <li>　「人文の結晶」：特殊なカード「芸術」と"意識ボーナス"を獲得します。</li>
            <li>　「外交交渉」：カードを用いてカードと交換できます。交換にはカードの"価値"を用います。</li>
            <li>意識/規模とデッキを強くして、終着点の脅威に打ち勝ちましょう！</li>
          </ul>
          <h3>Version 0.6.6 (2026/05/30)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：対戦中の一部演出を変更。</li>
          </ul>
          <h3>Version 0.6.5 (2026/05/25)</h3>
          <ul>
            <li><font color="yellow">仕様変更</font>：「隘路」に「ターン終了時、これの耐久値-3」を追加。</li>
            <li>　　変更経緯：「隘路」が半永続的な効果を持たないことによって、使用目的に変化を与えるため。</li>
            <li><font color="yellow">機能追加</font>：PC版「デッキ構築画面」でカード詳細をマウスオーバーで見れる機能を追加。</li>
          </ul>
          <h3>Version 0.6.3 (2026/05/18)</h3>
          <ul>
            <li><font color="yellow">機能追加</font>：ゲーム中の「デッキカード」「捨て札カード」確認機能の追加。</li>
            <li>ゲーム中「プレイヤー情報」を押下して見れる「プレイヤー詳細情報」に、自分のデッキ内や捨て札内のカードが表示されるようになります。</li>
            <li>「デッキカード」には次のドローで引ける確率も表示されていますので、次の一手のためにご活用ください。</li>
          </ul>
          <h3>Version 0.6.2 (2026/05/17)</h3>
          <ul>
            <li><font color="yellow">機能追加</font>：「公開済みカード」表示機能の追加。</li>
            <li>ゲーム中「プレイヤー情報」を押下して見れる「プレイヤー詳細情報」に、そのプレイヤーの公開済みカードが表示されるようになります。</li>
            <li><font color="yellow">画面調整</font>：PC等ワイド画面に於いてゲーム中の「プレイヤー情報」を拡張。</li>
            <li>「プレイヤー詳細情報」にのみ表示されていた対象プレイヤーの手札や捨て札の枚数などが拡張領域に表示されます。</li>
            <li>前述の「公開済みカード」もここに表示されます。</li>
          </ul>
          <h3>Version 0.6.1 (2026/05/15)</h3>
          <ul>
            <li><font color="yellow">機能追加</font>：「再開発計画」機能の追加。</li>
            <li>「再開発計画」は、自分のターンに使用できる特殊操作です。</li>
            <li>自分の場の財カードの枚数が上限の半数以上あるとき「再開発計画」ボタンが出現します。</li>
            <li>「再開発計画」を使用すると、自分の場の財カードをゲームから除外することができます。</li>
            <li>"役割を終えた財"や"捨て札になっても手札が減らず困る財"の適切な処理、単に場を空けることなどに是非ご活用ください。</li>
            <li>また「世の理＞闘争の掟＞ゲーム進行＞3.カードプレイフェーズ」に「再開発計画」の説明を追加しています。</li>
            <li><font color="yellow">仕様追加</font>：デッキインポート時に不正なデッキかチェックする機能を追加。</li>
          </ul>
          <h3>Version 0.5.6 (2026/05/10)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：「自由主義」の効果が自分のターン中に<font color="yellow">相手の規模が増加した際</font>にも反応してしまう不具合を修正。</li>
          </ul>
          <h3>Version 0.5.5 (2026/05/04)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：PC版におけるカスタムデッキのデッキ名入力とデッキ削除ができない不具合を修正。</li>
            <li><font color="yellow">仕様追加</font>：デッキ構築画面にトークンの表示非表示を切り替えるボタンを追加。</li>
            <li><font color="yellow">仕様変更</font>：「予感」の効果に「過去に「予感」で引いたカードを引かない」効果を追加。</li>
          </ul>
          <h3>Version 0.5.4 (2026/05/03)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：カスタムデッキを選択してゲームを開始するとエラーが出る不具合を修正。</li>
          </ul>
          <h3>Version 0.5.3 (2026/05/03)</h3>
          <ul>
            <li><font color="yellow">仕様追加</font>：デッキ構築画面に専用チュートリアルの追加。</li>
            <li><font color="yellow">画面調整</font>：一部画面を修正。</li>
            <li>　ゲーム終了画面の意識チャートのラベル「あなた」の色をプレイヤーカラーに修正。</li>
            <li>　カード効果表示時のウィンドウに、スライド時だけでなく常にスクロールバーが表示されるよう変更。</li>
            <li>　チュートリアル選択画面のチュートリアルタイトルが左揃えになるよう変更。</li>
            <li>　「リージョナリズム」の説明文にあった脱字を修正。</li>
            <li>　「解体」の説明文に財カードが無くても使用できることを追記。</li>
            <li>　「強制収用」の説明文に財カードが無くても使用できることを追記。</li>
            <li>　「結束主義」の説明文にカードがデッキにあっても反応することを追記。</li>
            <li>　「秩序の瓦解」の選択肢を相手のイデオロギーが上になるよう変更。</li>
            <li>　「原始共産制」配置中、手札の財カードに配置できないことを示す演出を追加。</li>
          </ul>
          <h3>Version 0.5.1 (2026/05/02)</h3>
          <ul>
            <li><font color="yellow">仕様追加</font>：SE及び音声関連仕様の追加。</li>
            <li><font color="yellow">仕様変更</font>：一部カード効果の変更。</li>
            <li>　「グローバリズム」：相手のデッキの一番上に「文化的影響」を加える効果を、既存効果にさらに追加。</li>
            <li>　　変更経緯：このカードの役割を全うすべく、内容をより効果的にするため。</li>
            <li>　「結束主義」：必要規模を999に変更し、相手の場にイデオロギーが配置された時に必要規模を0にし、イデオロギーが捨て札になると元の必要規模に戻るよう変更。</li>
            <li>　　変更経緯：モチーフらしさの強調と、序盤におけるゲームバランスの調整のため。</li>
          </ul>
          <h3>Version 0.4.6 (2026/04/27)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：多言語対応以降「悟りの道」の効果が正しく動作しなかった不具合を修正。</li>
          </ul>
          <h3>Version 0.4.5 (2026/04/22)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：表示のみの修正として「環境主義」の効果表記を実装に合わせて修正。(誤：「ターン開始時」、正：「ターン終了時」)</li>
          </ul>
          <h3>Version 0.4.4 (2026/04/18)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：一部の端末にて画面要素がつぶれてしまう表示を改善。</li>
            <li><font color="yellow">画面調整</font>：場のカードの必要規模を表示しないよう変更。</li>
            <li><font color="yellow">画面調整</font>：デッキ構築画面のカード一覧側のカードサイズを調整。</li>
          </ul>
          <h3>Version 0.4.3 (2026/04/14)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：ゲーム中に表示されるモーダルウィンドウが閉じる演出を追加。</li>
            <li><font color="yellow">不具合修正</font>：「聖典」の効果でカードを手札に加えるとき、ログで正常な表示がされない不具合を修正。</li>
            <li><font color="yellow">不具合修正</font>：相手が「自由主義」の効果でカードを手札に加えるとき、ログにカード名が表示がされてしまう不具合を修正。</li>
          </ul>
          <h3>Version 0.4.0 (2026/04/13)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：カードアイコンの追加。</li>
            <li><font color="yellow">機能追加</font>：多言語対応(ja/en)。</li>
            <li>　※ja以外は主に自動翻訳を用いています。</li>
            <li><font color="yellow">仕様変更</font>：一部カード効果の変更。</li>
            <li>　「リージョナリズム」：互いの意識の減少効果-1を追加。このイデオロギーらしさとして、経戦能力の向上を実現するため。</li>
            <li>　「共同体主義」：効果の内容は変更されないが、内部的な処理を変更し、意識の減少効果の軽減及び増幅効果の影響を受けないように変更。</li>
            <li>　「資本主義」：効果の内容は変更されないが、内部的な処理を変更し、耐久値割り振りのアルゴリズを正規分布に近づくよう調整。</li>
            <li>　「不干渉主義」：既存効果に加え、互いの場の財に与えるダメージを0にする効果を追加。</li>
          </ul>
          <h3>Version 0.2.2 (2026/03/11)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：新UIの適用により全体のグラフィックを調整</li>
            <li><font color="yellow">機能追加</font>：カードを獲得する効果を持つカードに「関連カードの表示機能」を追加</li>
            <li><font color="yellow">機能追加</font>：タイトル画面に「お問い合わせ」「アンケート」「免責事項」を追加</li>
            <li><font color="yellow">仕様変更</font>：一部カード効果の修正。</li>
            <li>　「資本主義」：ターン開始時効果に「自分の手札、デッキのすべてのカードの必要規模+6」と、場の財にダメージを与える前に「自分の場の財の数と同じだけ意識をプラス」を追加。自分の財カードに与えるダメージを場の財のうち最も低い耐久値の値に変更。また、ダメージ後に「場に残っている財カード」の耐久値+2する効果を追加。</li>
            <li>　　変更経緯：使用感の向上と合わせて能力に応じた調整を施すため。</li>
            <li>　「一神教」：捨て札時効果に「手札が上限に達していない」条件を追加し、規模減少効果を削除。</li>
            <li>　「受難」：規模減少効果を-5→-3に変更。</li>
            <li>　「崇拝」：意識上昇効果を+3→+1に変更。</li>
            <li>　「救世」：規模-10する効果を追加。</li>
            <li>　　変更経緯：「一神教」軸でのデッキ回しに於いて、進行状況による意識と規模のコントロール体験によりメリハリを与えるため。</li>
            <li>　「多文化主義」：効果の内容は変更されないが、内部的な処理を変更し、意識や規模の増減効果の軽減及び増幅効果の影響を受けないように変更。</li>
            <li>　　変更経緯：効果は外部との組み合わせによる柔軟性を失うが、内部効果同士の均衡を維持することで、使用に一定の緊張感を保つため。</li>
            <li>　「多極主義」：必要規模を60→40に変更。獲得するマネーの耐久値と減少する規模を「現在規模の50%→75%」に変更。イデオロギー捨て札時にデッキからカードを2枚引く効果を追加。</li>
            <li>　　変更経緯：ターン終了時効果の発動条件を満たしやすくしつつ、加える「マネー」の耐久値の実質的な維持と必要規模の低下による使いやすさ向上のため。</li>
            <li>　「環境主義」：ターン開始時効果を「場の財が3以上あれば自分の意識+3」から「場の財が3以上あれば自分の意識+2、相手の意識-1」に変更。</li>
            <li>　　変更経緯：彼我の期待される意識差を維持しつつ、効果の影響の多様さを広げるため。</li>
            <li>　「社会主義」：「マネー」使用時の財カードの耐久値+効果を2→5に変更し、ターン開始時効果に「手札とデッキの必要規模+3」を追加。</li>
            <li>　　変更経緯：耐久値加算効果の向上により使用感の向上を軸に調整したため。</li>
            <li>　「共産主義」：ターン開始時効果に「手札の古いカードを1枚捨て札にする」を追加。</li>
            <li>　　変更経緯：場の財カードが手札に戻る効果を補助しつつ、効果全体の均衡を取るため。</li>
            <li>　「リバタリアニズム」：「マネー」以外のカードを出すときの効果に、「相手の意識-1」を追加。ターン開始時効果に「デッキからカードを1枚引く」を追加。</li>
            <li>　　変更経緯：「自由主義」トークンにおける役割を明確にし、より尖った性能とするため。</li>
          </ul>
          <h3>Version 0.1.4 (2026/03/01)</h3>
          <ul>
            <li><font color="yellow">機能追加</font>：チュートリアルの追加(ゲーム開始 ＞ チュートリアル)</li>
            <li><font color="yellow">不具合修正</font>：「終末」「大地震」の効果が発動しない場合がある不具合を修正</li>
            <li><font color="yellow">仕様変更</font>：事象カードプレイ時のカード表示を、効果発動<font color="yellow">後</font>から効果発動<font color="yellow">前</font>へ変更</li>
            <li><font color="yellow">仕様変更</font>：一部カード効果の上方修正</li>
            <li>　「官僚主義」：ターン終了時に自分の手札(当カード除く)の必要規模-1する効果を追加</li>
            <li>　「多極主義」：手札に加わったイデオロギーを捨てるたび意識+2の効果を追加</li>
            <li>　「果実」：耐久値が0になったとき、正面の財カードをデッキに戻す効果を追加</li>
            <li>　　変更経緯：カード用途の拡張による、より幅のあるデッキ構築実現のため</li>
            <li><font color="yellow">表記変更</font>：「一神教」の一部性能を仕様に合わせて訂正。</li>
            <li>　　※性能自体の変更はありません。</li>
            <li>　修正前「配置時、手札とデッキのすべてのイデオロギーカードを捨て札にし、」</li>
            <li>　修正後「配置時、手札とデッキのすべてのイデオロギーカードを除外し、」</li>
          </ul>
          <h3>Version 0.0.4 (2026/01/13)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：カードUIの財カードの耐久値表示が見づらかったので調整</li>
          </ul>
          <h3>Version 0.0.3 (2026/01/12)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：カードUIの規模と財カードの耐久値の表示を調整</li>
          </ul>
          <h3>Version 0.0.2 (2026/01/11)</h3>
          <ul>
            <li><font color="yellow">画面調整</font>：モバイルUIの縦幅を少し縮め、画面内からややはみ出ていた情報が収まるよう調整</li>
          </ul>
          <h3>Version 0.0.1 (2025/12/25)</h3>
          <ul>
            <li><font color="yellow">不具合修正</font>：マリガンで引いたカードの存在箇所が正しくなく、一部のカード効果において正しい挙動をしなかったため修正</li>
            <li><font color="yellow">仕様変更</font>：「資本主義」のターン終了時効果を次のように修正</li>
            <li>　修正前「ターン終了時、場のマネーの耐久値と同じ回数ランダムな財の耐久値を+1し、」</li>
            <li>　修正後「ターン終了時、場のマネーの耐久値をランダムに場の財に耐久値を割り振ってプラスし、」</li>
            <li>　　変更経緯：「マネー」の耐久値が非常に多い場合、耐久値分の回数の処理が働くことでアニメーション負荷が高くなり正常にゲームが進行しなくなる場合があるため</li>
            <li><font color="yellow">機能追加</font>：この更新履歴を追加</li>
          </ul>
          <h3>Version 0.0.0 (2025/12/21)</h3>
          <ul>
            <li>公開</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ChangelogModal;